const printerUrl = () => import('@/views/main/marketing/printer/index.vue')
export default {
  path: '/main/marketing/printer',
  name: 'marketingPrinter',
  component: printerUrl,
  children: []
}
